import React, { useState, useEffect } from 'react';
import { flashMessage } from '../utils/flashMessage';
import './SessionTimeoutNotification.css';

/**
 * SessionTimeoutNotification Component
 * Displays a one-time flash message if session has expired
 * Automatically dismisses after 5 seconds or on user click
 */
export default function SessionTimeoutNotification() {
  const [message, setMessage] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if there's a flash message on component mount
    const flash = flashMessage.get();
    if (flash && flash.message) {
      setMessage(flash);
      setIsVisible(true);

      // Auto-dismiss after 5 seconds
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, []);

  if (!isVisible || !message) {
    return null;
  }

  const typeColorMap = {
    error: 'bg-red-100 border-red-400 text-red-700',
    warning: 'bg-yellow-100 border-yellow-400 text-yellow-700',
    success: 'bg-green-100 border-green-400 text-green-700',
    info: 'bg-blue-100 border-blue-400 text-blue-700'
  };

  const colorClass = typeColorMap[message.type] || typeColorMap.info;

  return (
    <div
      className={`fixed top-24 left-1/2 transform -translate-x-1/2 max-w-md px-6 py-3 border rounded-lg shadow-lg z-50 transition-all duration-300 ${colorClass}`}
      role="alert"
      onClick={() => setIsVisible(false)}
    >
      <div className="flex items-center justify-between">
        <span className="font-medium">{message.message}</span>
        <button
          onClick={() => setIsVisible(false)}
          className="ml-4 text-lg font-bold opacity-70 hover:opacity-100"
        >
          ×
        </button>
      </div>
    </div>
  );
}
